import { useMemo } from 'react';
import { Box, Center, ChakraProps, Container, Text } from '@chakra-ui/react';
import { Marker } from 'react-map-gl';

interface Props {
  clusterId: string | number | undefined;
  latitude: number;
  longitude: number;
  pointCount: number;
  onClickCluster(
    clusterId: string | number | undefined,
    lat: number,
    long: number,
  ): void;
}

export type ClusterMarkerProps = Props;

export const ClusterMarker = (props: Props) => {
  const { clusterId, latitude, longitude, pointCount, onClickCluster } = props;

  const onClick = () => {
    onClickCluster(clusterId, latitude, longitude);
  };

  const bgColor: ChakraProps['color'] = useMemo(() => {
    const colors: Array<ChakraProps['color']> = [
      'zmyle.primary',
      'zmyle.secondary',
      'network.primary',
      'network.secondary',
      'store.primary',
      'store.secondary',
    ];
    const randomIndex = Math.floor(Math.random() * colors.length);

    return colors[randomIndex];
  }, []);

  return (
    <Marker latitude={latitude} longitude={longitude}>
      <Container pos="relative" onClick={onClick} role="button">
        <Box
          p="0.5rem"
          bg={bgColor}
          opacity={0.5}
          rounded="full"
          w="2.625rem"
          h="2.625rem"
          shadow="xl"
        />

        <Center
          h="2rem"
          w="2rem"
          pos="absolute"
          top="50%"
          left="50%"
          bg={bgColor}
          rounded="full"
          transform="translate(-50%, -50%)"
        >
          <Text color="white" fontWeight="bold" fontSize="1.25rem">
            {pointCount}
          </Text>
        </Center>
      </Container>
    </Marker>
  );
};
